import svgIcons from '@/assets/svg/icons';
import { extra, primary } from '@/theme/colors/palettes';
import { Center } from '@chakra-ui/react';
import React from 'react';
import SvgIcon from '../SvgIcon';

interface Props {
  checked: boolean;
  onClick: () => void;
}

const MYOCheckbox = ({ checked, onClick }: Props) => {
  return (
    <Center
      width={'28px'}
      height={'28px'}
      border={`2px solid ${primary[200]}`}
      borderColor={checked ? primary[500] : primary[200]}
      borderRadius={'8px'}
      cursor={'pointer'}
      onClick={onClick}
      backgroundColor={checked ? primary[500] : 'transparent'}
    >
      {checked ? (
        <SvgIcon iconPath={svgIcons.check} color={extra.white} size={14} boxWidth={12} boxHeight={10} />
      ) : null}
    </Center>
  );
};

export default MYOCheckbox;
